import React, { useContext, useMemo } from 'react';

import { Collections } from 'Collections';
import { FirebaseUtils } from 'firebaseUtils/FirebaseUtils';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import { DbDoc, WithRef } from 'models/FbDoc';
import { DbDocIdMap } from 'models/IdMap';
import { PriceField } from 'models/PriceField';
import { sortAlphabetically } from 'Util/sortAlphabetically';
import { dbDocToIdMap } from 'Util/toIdMap';

import { useOrg } from './OrgProvider';
import { Snacbars } from './Snacbars';

type Props = {
    children: React.ReactNode
}

const PRICE_FIELD_SUGGESTIONS_CONTEXT = React.createContext<[value: DbDocIdMap<WithRef<DbDoc<PriceField>>> | null, loading: boolean]>([null, true])

export function usePriceFieldSuggestions() {
    return useContext(PRICE_FIELD_SUGGESTIONS_CONTEXT)
}

export function PriceFieldSuggestionsProvider({ children }: Props) {
    const [org, loadingOrg] = useOrg()
    const [suggestions, loadingSuggestions, error] = FirebaseUtils.useCollectionData<PriceField>(
        true,
        Collections.PRICE_FIELD_SUGGESTIONS,
        AnalyticsEvent.GET_PRICE_FIELD_SUGGESTIONS_ERROR,
        {},
        (query, path) => (
            org && query.where(path.data.org.id, '==', org?.data.id)
        ))

    const loading = loadingOrg || loadingSuggestions

    const orderedSuggestions = useMemo(() => {
        return suggestions ? dbDocToIdMap(suggestions?.sort((a, b) => sortAlphabetically(a.data.name?.text, b.data.name?.text))) : null
    }, [suggestions])

    return (
        <PRICE_FIELD_SUGGESTIONS_CONTEXT.Provider value={[orderedSuggestions || null, loading]}>
            <Snacbars error={error?.message} />
            {children}
        </PRICE_FIELD_SUGGESTIONS_CONTEXT.Provider>
    )
}
